// Optional browser storage must never prevent a funding inquiry.
// After a failure, stop using that store for this page visit. In particular,
// a failed consent update must not reactivate analytics using an old value.
const unavailable = new Set();
export function readStorage(store, key) {
  if (unavailable.has(store)) return null;
  try { return globalThis[store].getItem(key); }
  catch { unavailable.add(store); return null; }
}
export function writeStorage(store, key, value) {
  if (unavailable.has(store)) return false;
  try { globalThis[store].setItem(key, value); return true; }
  catch { unavailable.add(store); return false; }
}
export function removeStorage(store, key) {
  try { globalThis[store].removeItem(key); return true; }
  catch { unavailable.add(store); return false; }
}
